import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) return;

    // Check if dismissed recently
    const dismissed = localStorage.getItem('pwa-dismissed');
    if (dismissed) {
      const dismissedDate = new Date(dismissed);
      const daysSinceDismissed = (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
      if (daysSinceDismissed < 7) return; // Don't show for 7 days after dismissal
    }

    // Listen for beforeinstallprompt event
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Online/offline listeners
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-dismissed', new Date().toISOString());
  };

  return (
    <>
      {/* Offline indicator */}
      {!isOnline && (
        <div className="offline-indicator">
          Sei offline - Alcune funzionalità potrebbero non essere disponibili
        </div>
      )}

      {/* Install banner */}
      {showBanner && (
        <div className="pwa-install-banner" data-testid="pwa-install-banner">
          <div className="flex items-center gap-3">
            <Download className="w-6 h-6 text-orange-400" />
            <div>
              <p className="font-semibold">Installa RM DDR</p>
              <p className="text-sm text-slate-300">Accesso rapido dalla schermata Home</p>
            </div>
          </div>
          <div className="flex gap-2">
            <button onClick={handleDismiss} className="dismiss" aria-label="Chiudi">
              <X className="w-4 h-4" />
            </button>
            <button onClick={handleInstall} data-testid="install-pwa-btn">
              Installa
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PWAInstallPrompt;
